import { defineComponent as _defineComponent } from 'vue'
import { vModelRadio as _vModelRadio, createElementVNode as _createElementVNode, withDirectives as _withDirectives, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, unref as _unref, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3646ae98"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "mt-2",
  id: "modal_question"
}
const _hoisted_2 = { class: "formTable" }
const _hoisted_3 = { class: "col-sm-10 d-flex align-items-center" }
const _hoisted_4 = ["required"]
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "answer_true",
  class: "me-3"
}, "はい", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "answer_false",
  class: "me-3"
}, "いいえ", -1))
const _hoisted_7 = { class: "col-sm-10" }
const _hoisted_8 = { class: "col-sm-10" }
const _hoisted_9 = { class: "d-flex align-items-center p-2" }
const _hoisted_10 = {
  class: "remove-link",
  title: "削除"
}
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" その他の手続き可能な窓口を追加 ")
const _hoisted_12 = { class: "d-flex flex-row mb-2" }
const _hoisted_13 = { class: "flex-grow-1" }
const _hoisted_14 = { class: "row form-group mb-1" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-sm-2 col-form-label" }, "補足", -1))
const _hoisted_16 = { class: "col-sm-10" }

import {computed, reactive, ref} from 'vue'
import {
  ConciergeQuestionProcess
} from '@/plugins/nicotto'
import InputLinks from "@/components/ui/InputLinks.vue"
import FormGroup from "@/components/ui/FormGroup.vue"
import InputText from "@/components/ui/InputText.vue"
import InputTextArea from "@/components/ui/InputTextArea.vue"
import InputSelect from "@/components/ui/InputSelect.vue";
import IconCircleMinus from "@/components/ui/IconCircleMinus.vue";
import IconCirclePlus from "@/components/ui/IconCirclePlus.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'ModalQuestion',
  props: {
    modelValue: null,
    processList: null,
    departmentOption: null,
    typeQuestion: null
  },
  emits: ["update:modelValue", "submit"],
  setup(__props: any, { emit }: { emit: ({
  (event: 'update:modelValue', process: ConciergeQuestionProcess): void,
  (event: 'submit'): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  modelValue: ConciergeQuestionProcess
  processList: any[]
  departmentOption: any[]
  typeQuestion: string
}



// eslint-disable-next-line func-call-spacing


const keys = ['condition', 'processId', 'name', 'belongings', 'additionalContacts', 'supplement' ,'note' ,'links']
const process = reactive<any>({})
keys.forEach(key => {
  process[key] = computed({
    get() {
      return props.modelValue[key as keyof ConciergeQuestionProcess]
    },
    set(val) {
      emit('update:modelValue', new ConciergeQuestionProcess({ ...props.modelValue, [key]: val}))
    }
  })
})

// 電子申請
process.eApplication = {}
process.eApplication.supplement = computed({
  get() {
    return props.modelValue.eApplication?.supplement
  },
  set(val) {
    const eApplication = {
      supplement : val,
      link: props.modelValue.eApplication?.link
    }
    emit('update:modelValue', new ConciergeQuestionProcess({ ...props.modelValue, eApplication: eApplication }))
  }
})
process.eApplication.links = computed({
  get() {
    return [ props.modelValue.eApplication?.link ]
  },
  set(val) {
    const eApplication = {
      supplement : props.modelValue.eApplication?.supplement,
      link: val[0]
    }
    emit('update:modelValue', new ConciergeQuestionProcess({ ...props.modelValue, eApplication: eApplication}))
  }
})

const processOption = ref<any[]>(props.processList)

const maxLinkLength = ConciergeQuestionProcess.maxLinkLength
const maxAdditionalContactLength = ConciergeQuestionProcess.maxAdditionalContactLength

const addWindow = () => {
  if (process.additionalContacts.length < maxAdditionalContactLength) {
    process.additionalContacts.push("");
  }
}
const updateWindow = (window_index:number, window:string) => {
  if (process.additionalContacts.length < maxAdditionalContactLength) {
    process.additionalContacts[window_index] = window;
  }
}
const removeWindow = (window_index:number) => {
  process.additionalContacts.splice(window_index, 1);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("form", _hoisted_2, [
      (__props.typeQuestion === 'yes')
        ? (_openBlock(), _createBlock(FormGroup, {
            key: 0,
            label: "結果表示条件",
            required: __props.typeQuestion === 'yes',
            "label-for": "condition"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_3, [
                _withDirectives(_createElementVNode("input", {
                  type: "radio",
                  id: "answer_true",
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((process.condition) = $event)),
                  value: "yes",
                  required: __props.typeQuestion === 'yes'
                }, null, 8, _hoisted_4), [
                  [_vModelRadio, process.condition]
                ]),
                _hoisted_5,
                _withDirectives(_createElementVNode("input", {
                  type: "radio",
                  id: "answer_false",
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((process.condition) = $event)),
                  value: "no"
                }, null, 512), [
                  [_vModelRadio, process.condition]
                ]),
                _hoisted_6
              ])
            ]),
            _: 1
          }, 8, ["required"]))
        : _createCommentVNode("", true),
      _createVNode(FormGroup, {
        label: "手続き対象",
        required: true
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_7, [
            _createVNode(InputSelect, {
              modelValue: process.processId,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((process.processId) = $event)),
              options: processOption.value,
              result: "value",
              required: true,
              label: "手続き対象"
            }, null, 8, ["modelValue", "options"])
          ])
        ]),
        _: 1
      }),
      _createVNode(FormGroup, {
        label: "手続き種別",
        "label-for": "process_detail"
      }, {
        default: _withCtx(() => [
          _createVNode(InputText, {
            id: "process_detail",
            modelValue: process.name,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((process.name) = $event))
          }, null, 8, ["modelValue"])
        ]),
        _: 1
      }),
      _createVNode(FormGroup, {
        label: "持ち物",
        "label-for": "belongings"
      }, {
        default: _withCtx(() => [
          _createVNode(InputTextArea, {
            rows: 6,
            id: "belongings",
            modelValue: process.belongings,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((process.belongings) = $event))
          }, null, 8, ["modelValue"])
        ]),
        _: 1
      }),
      _createVNode(FormGroup, { label: "その他の手続き可能な窓口" }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_8, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(process.additionalContacts, (add_window, window_index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: window_index,
                class: "d-flex mb-2"
              }, [
                _createVNode(InputSelect, {
                  modelValue: process.additionalContacts[window_index],
                  "onUpdate:modelValue": ($event: any) => ((process.additionalContacts[window_index]) = $event),
                  options: __props.departmentOption,
                  result: "value",
                  onChange: ($event: any) => (updateWindow(window_index, process.additionalContacts[window_index]))
                }, null, 8, ["modelValue", "onUpdate:modelValue", "options", "onChange"]),
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("span", _hoisted_10, [
                    _createVNode(IconCircleMinus, {
                      onClick: ($event: any) => (removeWindow(window_index))
                    }, null, 8, ["onClick"])
                  ])
                ])
              ]))
            }), 128)),
            (process.additionalContacts?.length < _unref(maxAdditionalContactLength))
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  class: "btn btn-sm btn-link p-0 add-link",
                  type: "button",
                  onClick: _cache[5] || (_cache[5] = ($event: any) => (addWindow()))
                }, [
                  _createVNode(IconCirclePlus),
                  _hoisted_11
                ]))
              : _createCommentVNode("", true)
          ])
        ]),
        _: 1
      }),
      _createVNode(FormGroup, {
        label: "窓口補足",
        "label-for": "capture"
      }, {
        default: _withCtx(() => [
          _createVNode(InputTextArea, {
            id: "capture",
            modelValue: process.supplement,
            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((process.supplement) = $event))
          }, null, 8, ["modelValue"])
        ]),
        _: 1
      }),
      _createVNode(FormGroup, { label: "関連リンク" }, {
        default: _withCtx(() => [
          _createVNode(InputLinks, {
            modelValue: process.links,
            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((process.links) = $event)),
            "max-length": _unref(maxLinkLength)
          }, null, 8, ["modelValue", "max-length"])
        ]),
        _: 1
      }),
      _createVNode(FormGroup, { label: "電子申請" }, {
        default: _withCtx(() => [
          _createVNode(InputLinks, {
            modelValue: process.eApplication.links,
            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((process.eApplication.links) = $event)),
            "min-length": 1,
            "max-length": 1
          }, null, 8, ["modelValue"]),
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("div", _hoisted_14, [
                _hoisted_15,
                _createElementVNode("div", _hoisted_16, [
                  _createVNode(InputTextArea, {
                    id: "note",
                    modelValue: process.eApplication.supplement,
                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((process.eApplication.supplement) = $event))
                  }, null, 8, ["modelValue"])
                ])
              ])
            ])
          ])
        ]),
        _: 1
      }),
      _createVNode(FormGroup, {
        label: "備考",
        "label-for": "note"
      }, {
        default: _withCtx(() => [
          _createVNode(InputTextArea, {
            id: "note",
            modelValue: process.note,
            "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((process.note) = $event))
          }, null, 8, ["modelValue"])
        ]),
        _: 1
      })
    ])
  ]))
}
}

})